import { render, staticRenderFns } from "./PostModalForm.vue?vue&type=template&id=6801306d"
import script from "./PostModalForm.vue?vue&type=script&lang=js"
export * from "./PostModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports